export type RejectStates = {
  reason: string;
};

const rejectStates: RejectStates = {
  reason: "",
};

export default rejectStates;
